import { store } from '@utils/configStore'
import videoReportReducer from './slices'

export const injectVideoReport = () => store.injectReducer('videoReport', videoReportReducer)
